import { render, staticRenderFns } from "./drugsProtocolSetupList.vue?vue&type=template&id=0dfe738d&"
import script from "./drugsProtocolSetupList.vue?vue&type=script&lang=js&"
export * from "./drugsProtocolSetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports